import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getStatus } from 'find-and-filter-data/search-and-filter-schema/protected';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import ChatFilterOptions from 'conversations-internal-schema/constants/ChatFilterOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const StatusFilter = () => {
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const placeholder = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.threadStatus.placeholder"
  });
  const options = [{
    text: I18n.text('conversations-inbox-ui.buttons.filterOptions.threadStatus.STARTED'),
    value: ChatFilterOptions.STARTED
  }, {
    text: I18n.text('conversations-inbox-ui.buttons.filterOptions.threadStatus.ENDED'),
    value: ChatFilterOptions.ENDED
  }];
  const onChange = e => {
    const {
      value
    } = e.target;
    if (value) setFilterValue('threadStatus', [value]);else setFilterValue('threadStatus', null);
  };
  const status = getStatus(filterValues);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.threadStatus.title"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      clearable: true,
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      value: status && status[0],
      "data-test-id": "search-and-filtering-status-filter"
    })
  });
};
StatusFilter.displayName = 'StatusFilter';
export default StatusFilter;